import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

interface HubCardBaseSkeletonProps {
  actionsElement: React.ReactNode;
  children?: React.ReactNode;
  childrenStyle?: StyleProp<ViewStyle>;
}

export const HubCardBaseSkeleton: React.FC<HubCardBaseSkeletonProps> = ({
  actionsElement,
  children,
  childrenStyle,
}) => {
  const [styles] = useStyles();
  return (
    <View style={styles.container}>
      <View
        accessibilityRole="progressbar"
        accessibilityState={{ busy: true }}
        accessible
        style={styles.header}
      >
        <View style={styles.titleContainer}>
          <AnimatedSkeletonLoader height={22.4} width="80%" />
          <AnimatedSkeletonLoader height={18} width="60%" />
        </View>
        {actionsElement ? actionsElement : null}
      </View>
      <View style={[styles.contentContainer, childrenStyle]}>{children}</View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 12,
    padding: 16,
    width: '100%',
  },
  contentContainer: {
    width: '100%',
  },
  header: {
    flexDirection: 'row',
    gap: 8,
  },
  titleContainer: {
    flex: 9,
  },
}));
